export default __webpack_public_path__ + "static/media/shashank.2129ce68.webp";